// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3D_t6","buttons":"Footer_buttons__3XFyU"};